import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SimpleProduct } from 'app/models/product/product/simple-product';
import { Product } from 'app/pages/products/product';

@Component({
  selector: 'discount-info',
  templateUrl: './discount-info.component.html',
  styleUrls: ['./discount-info.component.scss']
})
export class DiscountInfoComponent implements OnInit, OnChanges {
  @Input() product: Product | SimpleProduct;
  @Input() indexPrice: number;
  @Input() measurementQuantity: number;

  showDiscount: boolean = false;
  showListPriceParam: boolean = false;
  percentageDifference: number;
  listPrice: number;

  constructor() { }

  ngOnInit(): void {
    this.setShowListPriceParam();
    this.setListPrice();
    this.showDiscount = this.verifyIfShowDiscount();
    this.percentageDifference = this.calculatePercentage();
  }
    
  ngOnChanges(changes: SimpleChanges): void {
    this.setListPrice();
    this.showDiscount = this.verifyIfShowDiscount();
    this.percentageDifference = this.calculatePercentage();
  }

  setShowListPriceParam() {
    this.showListPriceParam = JSON.parse(
      sessionStorage.getItem("showListPrice")
    ) ?? false;
  }

  setListPrice() {
    this.listPrice = this.product.listPrice * this.indexPrice * this.measurementQuantity
  }

  verifyIfShowDiscount() {
    let price = this.product.offerPrice != 0 ? this.product.offerPrice : this.product.price;
    
    price *= this.indexPrice * this.measurementQuantity;

    const hasNegativedVariation = this.listPrice > price;

    return this.showListPriceParam && hasNegativedVariation;
  }

  calculatePercentage(): number {
    return Number.parseFloat((((this.product.price * 100 / this.product.listPrice) - 100) / 100).toPrecision(2));
  }

}
